import { ArcElement, BarController, BarElement, CategoryScale, Chart, Legend, LinearScale, PieController, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export function registerChartDefaults(): void {
  Chart.register(BarController, PieController, CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend, ChartDataLabels);
}
